<template>
    <header>
        <div class="header">
            <img class="logo" src="../../assets/logoAEL70.png"/>
        </div>
    </header>
</template>


<style>

.header {
    -moz-transition: opacity 0.2s;
    -webkit-transition: opacity 0.2s;
    -ms-transition: opacity 0.2s;
    transition: opacity 0.2s;
    background-color: #F5F5F5;
    height: 8.5vh;
    line-height: 4em;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    box-shadow:0px 2px 10px 0px rgba(44, 45, 73, 0.25);
}
    .header .logo {
        width: 13vh;
        margin: 2vh 4vh;
        display: inline-block;
    }

</style>

<script>
export default {
    name: 'Toolbar'
}
</script>

